import { toast } from "react-toastify";

// Configurações padrão para todos os toasts
const defaultOptions = {
  position: "top-right",
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

// Toast de sucesso customizado
export const successToast = (message, options = {}) => {
  return toast.success(message, {
    ...defaultOptions,
    ...options,
  });
};

// Toast de erro customizado
export const errorToast = (message, options = {}) => {
  return toast.error(message, {
    ...defaultOptions,
    autoClose: 5000, // Erros ficam mais tempo
    ...options,
  });
};

// Toast de aviso customizado
export const warningToast = (message, options = {}) => {
  return toast.warning(message, {
    ...defaultOptions,
    ...options,
  });
};

// Toast de informação customizado
export const infoToast = (message, options = {}) => {
  return toast.info(message, {
    ...defaultOptions,
    ...options,
  });
};

// Toast customizado com ícone personalizado
export const customToast = (message, type = "success", icon = null, options = {}) => {
  const toastOptions = {
    ...defaultOptions,
    ...options,
  };

  if (icon) {
    toastOptions.icon = icon;
  }

  switch (type) {
    case "success":
      return toast.success(message, toastOptions);
    case "error":
      return toast.error(message, toastOptions);
    case "warning":
      return toast.warning(message, toastOptions);
    case "info":
      return toast.info(message, toastOptions);
    default:
      return toast(message, toastOptions);
  }
};

// Exemplos de uso:
// successToast("Agendamento salvo com sucesso!");
// errorToast("Erro ao salvar agendamento");
// warningToast("Atenção: Verifique os dados");
// infoToast("Informação importante");
// customToast("Mensagem customizada", "success", "🎉");